import { useMemo } from 'react';
import { decodeObjFromUriParam } from '@namespace/helpers';
// eslint-disable-next-line @alf/loop-deps
import { useSearchParams } from '@namespace/router';

export const useEncodedSearchParam = (
  paramName: string = 'data'
): object | null => {
  const { [paramName]: data } = useSearchParams();

  return useMemo(() => decodeObjFromUriParam(data), [data]);
};
